import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export default function Register() {
  const { register } = useAuth();
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await register(form);
      toast.success("Account created!");
      navigate("/");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Sign up failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="max-w-md mx-auto px-6 py-20">
      <div className="overline">Join Eko</div>
      <h1 className="font-display text-4xl mt-2">Create your account</h1>
      <form onSubmit={submit} className="mt-8 space-y-4">
        <input data-testid="reg-name" required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Your name" className="input-eko" />
        <input data-testid="reg-email" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="Email" className="input-eko" />
        <input data-testid="reg-phone" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} placeholder="Phone (optional)" className="input-eko" />
        <input data-testid="reg-password" type="password" required minLength={6} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} placeholder="Password (min 6)" className="input-eko" />
        <button data-testid="reg-submit" disabled={loading} className="btn-primary w-full justify-center">{loading ? "Creating…" : "Create Account"}</button>
      </form>
      <p className="mt-6 text-sm text-[#6C665F]">Already have an account? <Link to="/login" className="link-underline text-[#8C3A3A]">Sign in</Link></p>
    </div>
  );
}
